import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#0AA1F4"
        d="M8 15.819l-4.243-4.243a6 6 0 118.486 0L8 15.82zm3.3-5.186a4.666 4.666 0 10-6.6 0l3.3 3.3 3.3-3.3zM8 8.667A1.333 1.333 0 118 6a1.333 1.333 0 010 2.667z"
      ></path>
    </svg>
  )
}

export default Icon
